import { type ISearchParam } from '@interface/ICommon';
import { type IDicItemList, type IDicParams } from '@interface/IItemDic';
import { Trans } from 'react-i18next';
import { DicItem } from './DicItem';

export const ItemList = ({
    listData,
    priceListParam,
    loading,
    params,
}: {
    listData: IDicItemList['contents'] | undefined;
    priceListParam: ISearchParam;
    loading: boolean;
    params: IDicParams;
}) => {
    if (!listData) return null;

    return (
        <section className="gameinfo-result__list">
            {loading && (
                <div className="gameinfo-loader is-show">
                    <span className="loader" />
                </div>
            )}

            {listData.length < 1 && (
                <div className="nodata" style={{ display: 'block' }}>
                    <Trans components={{ i: <i />, div: <div /> }} i18nKey={setNoResultandFavs(params)} />
                </div>
            )}

            <div className="ui-table" data-tabletype="item" style={{ display: listData.length < 1 ? 'none' : 'block' }}>
                <div className="tablehead">
                    <div className="tablerow">
                        <div className="tablecell"></div>
                        <div className="tablecell">아이템명</div>
                        <div className="tablecell">카테고리</div>
                        <div className="tablecell">옵션</div>
                    </div>
                </div>
                <div className="tablebody">
                    {listData.map((it, idx) => (
                        <DicItem
                            key={idx + '_' + it.id + it.favorite.toString() + it.grade + params.paramPage + params.paramQuery}
                            it={it}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

const setNoResultandFavs = (params: IDicParams) => {
    const { paramFavorite } = params;
    let result = '';
    if (paramFavorite !== 'true') {
        result = 'common.noresultsitemprice';
    } else if (paramFavorite === 'true') {
        result = 'common.noresultsfavs';
    }
    return result;
};
